const experiences = [
  {
    key: 'Arcana',
    designation: 'Software Engineer',
    name: 'Arcana Analytics Pvt. Ltd.',
    duration: 'July 2022 - Present',
    description: 'Working on Next.js, React, GraphQL, Python-Django',
  },
  {
    key: 'Tesco',
    designation: 'Software Engineer',
    name: 'Tesco Pvt. Ltd.',
    duration: 'November 2020 - June 2022',
    description: 'Working on React, Python - Django',
  },
  {
    key: 'Unilodgers',
    designation: 'Software Engineer',
    name: 'Unilodgers Pvt. Ltd.',
    duration: 'August 2019 - November 2020',
    description: 'Working mainly on Ruby on Rails and React.',
  },
  {
    key: 'Auquan',
    designation: 'Full Stack Developer Intern',
    name: 'Auquan Pvt. Ltd.',
    duration: 'January 2019 - May 2019',
    description: '',
  },
  {
    key: 'CampK12',
    designation: 'Full Stack Developer Intern',
    name: 'Camp K12 Pvt. Ltd.',
    duration: 'June 2018 - October 2018',
    description: '',
  },
  {
    key: 'Brandlitic',
    designation: 'Full Stack Developer Intern',
    name: 'Brandlitic Pvt. Ltd.',
    duration: 'December 2017 - May 2018',
    description: '',
  },
  {
    key: 'WhizzyGeeks',
    designation: 'Android Developer Intern',
    name: 'Whizzy Geeks Pvt. Ltd.',
    duration: 'June 2017 - August 2017',
    description: '',
  },
  {
    key: 'Hojaofit',
    designation: 'Web Developer Intern',
    name: 'Hojaofit Pvt. Ltd.',
    duration: 'June 2016 - July 2016',
    description: '',
  },
];

export default experiences;
